import React, { useState } from 'react'
import styled from 'styled-components'
import TabBar from './tabs-bar'
import PropTypes from 'prop-types'

const TabsStyled = styled.div`
  .tabs-content {
    display: none;
    &.is-active {
      display: block;
    }
  }
`

function Tabs({ options = [], tabActive }) {
  return (
    <TabsStyled>
      {
        options.map(tab => (
          <div key={tab.id} className={`tabs-content ${tab.id.includes(tabActive)  && 'is-active'}`}>
            {tab.component}
          </div>
        ))
      }
    </TabsStyled>
  )
}

Tabs.propTypes = {
  options: PropTypes.array.isRequired,
  tabActive: PropTypes.string,
}

export default Tabs
